import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Info } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-[#FFFBF5]">
      <Header />
      <main className="max-w-xl mx-auto px-6 py-24 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-stone-100 flex items-center justify-center mb-6">
          <Info size={30} className="text-stone-500" />
        </div>
        <h1 className="text-[36px] font-extrabold text-stone-900" style={{ fontFamily: 'Plus Jakarta Sans' }}>
          No worries — no charge was made.
        </h1>
        <p className="mt-3 text-stone-600">
          You can pick up right where you left off. Any questions before you subscribe? Reply to hello@ambanji.com.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/pricing" className="px-6 py-3 text-[13px] font-bold text-white bg-[#4F46E5] rounded-lg hover:bg-[#4338CA] transition inline-flex items-center justify-center gap-2">
            <ArrowLeft size={14} /> Back to pricing
          </Link>
          <Link to="/" className="px-6 py-3 text-[13px] font-bold text-stone-800 border border-stone-300 rounded-lg hover:bg-stone-100 transition">
            Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PaymentCancel;
